import { cn } from "@theprelude/core";
import { useId } from "react";

export const SentinelOneIcon: React.FC<
  React.ComponentPropsWithoutRef<"svg">
> = ({ className, ...props }) => {
  const clipPathId = useId();

  return (
    <svg
      className={cn("size-4 flex-shrink-0", className)}
      {...props}
      viewBox="0 0 24 25"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <g clipPath={`url(#${clipPathId})`}>
        <path d="M13.2598 0H10.0271V19.3286H13.2598V0Z" fill="currentColor" />
        <path
          fillRule="evenodd"
          clipRule="evenodd"
          d="M14.043 23.99L17.2732 21.9883V5.25438C16.3156 4.54427 15.2123 4.05546 14.043 3.82319V23.99Z"
          fill="currentColor"
        />
        <path
          fillRule="evenodd"
          clipRule="evenodd"
          d="M6.00378 21.9983L9.23648 24V3.83319C8.06705 4.06196 6.96295 4.54735 6.00378 5.25438V21.9983Z"
          fill="currentColor"
        />
        <path
          fillRule="evenodd"
          clipRule="evenodd"
          d="M18.0563 0.918265V21.638L19.5576 20.7073C20.0951 20.3536 20.5349 19.8702 20.8362 19.3017C21.1375 18.7332 21.2907 18.0979 21.2815 17.4545V7.66889C21.289 4.84654 18.0563 0.918265 18.0563 0.918265Z"
          fill="currentColor"
        />
        <path
          fillRule="evenodd"
          clipRule="evenodd"
          d="M2.00045 17.447C1.9906 18.0905 2.14345 18.7261 2.44483 19.2947C2.74621 19.8633 3.18634 20.3466 3.72438 20.6997L5.22564 21.6305V0.918265C5.22564 0.918265 2.00045 4.84654 2.00045 7.66889V17.447Z"
          fill="currentColor"
        />
      </g>
      <defs>
        <clipPath id={clipPathId}>
          <rect
            width="24"
            height="24"
            fill="white"
            transform="translate(0 0.213257)"
          />
        </clipPath>
      </defs>
    </svg>
  );
};
